import {
  View,
  Text,
  Dimensions,
  TouchableOpacity,
  ScrollView,
} from "react-native";
import { Feather, MaterialCommunityIcons } from "@expo/vector-icons";
import React, { useEffect, useRef, useState } from "react";
import {
  Input,
  Row,
  BackButton,
  Categories,
  Centered,
  Button,
} from "../../components/all";
import { normalize } from "../../utils/normalize";
import { useQuery } from "@tanstack/react-query";
import { getLocation } from "../../services/job";
import { useDispatch, useSelector } from "react-redux";
import {
  addRecentSearch,
} from "../../reducers/search/recentSearch";
import {
  setSearchFilter,
} from "../../reducers/search/searchFilter";
import { useCitiesByCountry } from "../../hooks/useCitiesByCountry";
import { useDebounce } from "../../hooks/useDebounce";
import { COUNTRIES } from "../../constants/countries";
import VirtualizedCategories from "../../components/VirtualizedCategories";

export default function (props) {
  const searchInputRef = useRef();
  const [searchText, setSearchText] = useState("");
  const debouncedSearchText = useDebounce(searchText, 300);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [searchQueries, setSearchQueries] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);

  const dispatch = useDispatch();

  const {
    data: locationQuery,
    refetch,
    isLoading,
    isFetched: locationFetched,
  } = useQuery(["filterLocation", { query: searchQueries, country: countryName }], getLocation, {
    cacheTime: 0,
  });
  const { recentSearch } = useSelector((state) => state.recentSearch);
  const { filters } = useSelector((state) => state.searchFilter);
  const { country } = useSelector((state) => state.user);
  
  // Get cities for the user's country
  const countryCode = country || "MY";
  const countryName = COUNTRIES[countryCode]?.name || "Malaysia";
  const { 
    data: stateCities = [], 
    isLoading: citiesLoading, 
    isError: citiesError,
    refetch: refetchCities,
    isUsingFallback 
  } = useCitiesByCountry(countryCode);
  
  // Check if we should use virtualized list (for large datasets)
  const useVirtualized = countryCode === 'PH' || stateCities.length > 100;

  let locations = locationQuery?.data?.data;

  useEffect(() => {
    console.log(filters.selectedLocations)
    if (filters.selectedLocations) {
      setSelectedLocation(filters.selectedLocations.map((item) => item.slug));
    }
  }, []);

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef?.current.focus();
    }
  }, [searchInputRef]);

  useEffect(() => {
    if (locationQuery?.data) {
      setSearchLoading(false);
    }
  }, [locationQuery]);




  const setCurrentLocation = () => {
    setSearchText("");
    const { location, ...newFilters } = filters;
    dispatch(
      setSearchFilter({
        ...newFilters,
      })
    );
    props.navigation.goBack();
  };

  const pickedItem = (index) => {
    console.log("=== SEARCH LOCATION: pickedItem called ===");
    console.log("Selected index:", index);

    let item = null;
    let isStateLevel = false;

    // First check if it's a direct match (parent/state level)
    item = stateCities.find((o) => o.slug === index);
    if (item) {
      isStateLevel = true;
    }

    // If not found at parent level, search in children (city level)
    if (!item) {
      for (const state of stateCities) {
        const childItem = state.children?.find((c) => c.slug === index);
        if (childItem) {
          item = childItem;
          console.log("Found item in children of state:", state.name);
          break;
        }
      }
    }

    console.log("Found RAW item:", JSON.stringify(item, null, 2));
    console.log("Is state level:", isStateLevel);

    // For state-level items, always use first child's coordinates with zoom adjustment
    if (item && isStateLevel && item.children && item.children.length > 0) {
      const firstChild = item.children[0];
      if (firstChild && firstChild.coord) {
        const coords = firstChild.coord.split(",").map(c => c.trim());
        const latitude = parseFloat(coords[0]);
        const longitude = parseFloat(coords[1]);

        if (!isNaN(latitude) && !isNaN(longitude)) {
          item = {
            ...item,
            latitude: latitude,
            longitude: longitude,
            coordinates: {  // Override the coordinates object as well
              lat: latitude,
              lng: longitude
            },
            zoomLevel: 8, // Zoomed out view for states
            delta: 0.8, // Wider delta for states to show more area
          };
          console.log(`Using first child (${firstChild.name}) coordinates for state ${item.name} with zoom level 8`);
          console.log("ENHANCED state item with first child coordinates:", JSON.stringify(item, null, 2));
        }
      }
    } else if (item && item.coord) {
      // For city-level items, use their own coordinates
      const coords = item.coord.split(",").map(c => c.trim());
      const latitude = parseFloat(coords[0]);
      const longitude = parseFloat(coords[1]);

      // Validate coordinates
      if (!isNaN(latitude) && !isNaN(longitude)) {
        item = {
          ...item,
          latitude: latitude,
          longitude: longitude,
          zoomLevel: 12, // Normal zoom for cities
          delta: 0.3, // Normal delta for cities
        };
        console.log("ENHANCED city item with parsed coordinates:", JSON.stringify(item, null, 2));
      } else {
        console.error(`Invalid coordinates for ${item.name}: ${item.coord}`);
      }
    }

    let newSelected = [...selectedLocation];
    if (newSelected.includes(index)) {
      newSelected = newSelected.filter((item) => {
        return ![index].includes(item);
      });
    } else {
      if (selectedLocation.length > 0 && !index.includes("-")) {
        // check if each of the selected location consist of dash in the slug
        const isDash = selectedLocation.some((location) => location.includes("-"));
        if (isDash) {
          newSelected = [index];
        } else {
          newSelected = [...selectedLocation, index];
        }
      } else {
        newSelected = [index];

      }
      item = {
        ...item,
        address_line_1: item.name,
      }

      console.log("FINAL item to dispatch to Redux:", JSON.stringify(item, null, 2));
      console.log("Item coordinates - lat:", item.latitude, "lng:", item.longitude);
      console.log("Original coord string:", item.coord);
      
      dispatch(
        addRecentSearch({
          type: "location",
          data: item.address_line_1,
        })
      );
      dispatch(
        setSearchFilter({
          ...filters,
          location: item,
        })
      );
      console.log("Dispatched location to Redux");
      // props.navigation.goBack();
    }


    setSelectedLocation(newSelected);
  };

  const onConfirm = () => {
    console.log("=== SEARCH LOCATION: onConfirm called ===");
    console.log("selectedLocation array:", selectedLocation);

    // get all the selected location items and parse their coordinates
    const selectedLocations = selectedLocation.map((itemSlug) => {
      let location = null;
      let isStateLevel = false;

      // First check if it's a direct match (parent/state level)
      location = stateCities.find((o) => o.slug === itemSlug);
      if (location) {
        isStateLevel = true;
      }

      // If not found at parent level, search in children (city level)
      if (!location) {
        for (const state of stateCities) {
          const childItem = state.children?.find((c) => c.slug === itemSlug);
          if (childItem) {
            location = childItem;
            console.log(`Found ${itemSlug} in children of state:`, state.name);
            break;
          }
        }
      }

      console.log(`RAW location for ${itemSlug}:`, JSON.stringify(location, null, 2));
      console.log(`Is state level: ${isStateLevel}`);

      // For state-level items, always use first child's coordinates with zoom adjustment
      if (location && isStateLevel && location.children && location.children.length > 0) {
        const firstChild = location.children[0];
        if (firstChild && firstChild.coord) {
          const coords = firstChild.coord.split(",").map(c => c.trim());
          const latitude = parseFloat(coords[0]);
          const longitude = parseFloat(coords[1]);

          if (!isNaN(latitude) && !isNaN(longitude)) {
            location = {
              ...location,
              latitude: latitude,
              longitude: longitude,
              coordinates: {  // Override the coordinates object as well
                lat: latitude,
                lng: longitude
              },
              zoomLevel: 8, // Zoomed out view for states
              delta: 0.8, // Wider delta for states to show more area
            };
            console.log(`Using first child (${firstChild.name}) coordinates for state ${location.name} with zoom level 8`);
            console.log(`ENHANCED state location for ${itemSlug}:`, JSON.stringify(location, null, 2));
          }
        }
      } else if (location && location.coord) {
        // For city-level items, use their own coordinates
        const coords = location.coord.split(",").map(c => c.trim());
        const latitude = parseFloat(coords[0]);
        const longitude = parseFloat(coords[1]);

        // Validate and enhance with parsed coordinates
        if (!isNaN(latitude) && !isNaN(longitude)) {
          location = {
            ...location,
            latitude: latitude,
            longitude: longitude,
            zoomLevel: 12, // Normal zoom for cities
            delta: 0.3, // Normal delta for cities
          };
          console.log(`ENHANCED city location for ${itemSlug} with coordinates:`, JSON.stringify(location, null, 2));
        } else {
          console.error(`Invalid coordinates for ${location.name}: ${location.coord}`);
        }
      }
      return location;
    });

    console.log("FINAL selectedLocations with parsed coords:", JSON.stringify(selectedLocations, null, 2));

    if (selectedLocations.length > 1) {
      const states = selectedLocations.map((item) => item.name);
      console.log("Multiple locations - states:", states);
      dispatch(
        setSearchFilter({
          ...filters,
          states: states,
          selectedLocations,
        })
      );
    } else {
      console.log("Single location to save:", JSON.stringify(selectedLocations[0], null, 2));
      console.log("Location coordinates - lat:", selectedLocations[0]?.latitude, "lng:", selectedLocations[0]?.longitude);
      dispatch(
        setSearchFilter({
          ...filters,
          location: selectedLocations[0],
          states: [selectedLocations[0].name],
          selectedLocations,
        })
      );
    }
    console.log("Dispatched to Redux and navigating back");
    props.navigation.goBack();
  }


  return (
    <View>
      <BackButton />
      <View style={{ paddingHorizontal: 24 }}>
        <View style={{ marginBottom: 24, marginTop: -40 }}>
          <Row style={{ justifyContent: "flex-end" }} centered>
            <TouchableOpacity onPress={setCurrentLocation}>
              <Row centered>
                <Text style={{ marginRight: 8 }}>Set Current Location</Text>
                <MaterialCommunityIcons name="target" size={20} color="black" />
              </Row>
            </TouchableOpacity>
          </Row>
        </View>
        <Input
          icon={<Feather name="search" />}
          placeholder={`Search by state or city in ${countryName}`}
          bordered={true}
          autoComplete="off"
          autoCorrect={false}
          ref={searchInputRef}
          value={searchText}
          onChangeText={(text) => setSearchText(text)}
        />
        <ScrollView
          showsVerticalScrollIndicator={false}
          style={{
            height: Dimensions.get("window").height - 250,
            paddingTop: 24,
          }}
        >
          {citiesLoading ? (
            <View style={{ padding: 20 }}>
              <Text style={{ textAlign: 'center' }}>Loading cities...</Text>
            </View>
          ) : citiesError && !isUsingFallback ? (
            <View style={{ padding: 20 }}>
              <Text style={{ textAlign: 'center', marginBottom: 10 }}>
                Failed to load cities data
              </Text>
              <TouchableOpacity onPress={refetchCities}>
                <Text style={{ textAlign: 'center', color: '#007AFF' }}>
                  Tap to retry
                </Text>
              </TouchableOpacity>
            </View>
          ) : (
            <>
              {isUsingFallback && (
                <View style={{ paddingHorizontal: 20, paddingBottom: 10 }}>
                  <Text style={{ fontSize: 12, color: '#666', textAlign: 'center' }}>
                    Using offline data
                  </Text>
                </View>
              )}
              {useVirtualized ? (
                <VirtualizedCategories
                  data={stateCities.map((o) => {
                    const coords = o.coord ? o.coord.split(",").map(c => c.trim()) : ["0", "0"];
                    const latitude = parseFloat(coords[0]);
                    const longitude = parseFloat(coords[1]);
                    
                    // Validate coordinates
                    if (isNaN(latitude) || isNaN(longitude)) {
                      console.error(`Invalid coordinates for ${o.name}: ${o.coord}`);
                    }
                    
                    const mappedItem = {
                      ...o,
                      address_line_1: o.value,
                      latitude: latitude,
                      longitude: longitude,
                    };
                    
                    if (o.name === "Pahang" || o.name.includes("Pahang")) {
                      console.log(`City ${o.name} - coord: ${o.coord} -> lat: ${mappedItem.latitude}, lng: ${mappedItem.longitude}`);
                      console.log(`Parsed types - lat: ${typeof mappedItem.latitude}, lng: ${typeof mappedItem.longitude}`);
                    }
                    
                    return mappedItem;
                  })}
                  selected={selectedLocation}
                  onPress={(index) => {
                    pickedItem(index);
                  }}
                  filterText={debouncedSearchText}
                  isCheckbox
                />
              ) : (
                <Categories
                  show={false}
                  hideLabel
                  data={stateCities.map((o) => {
                    const coords = o.coord ? o.coord.split(",").map(c => c.trim()) : ["0", "0"];
                    const latitude = parseFloat(coords[0]);
                    const longitude = parseFloat(coords[1]);
                    
                    // Validate coordinates
                    if (isNaN(latitude) || isNaN(longitude)) {
                      console.error(`Invalid coordinates for ${o.name}: ${o.coord}`);
                    }
                    
                    const mappedItem = {
                      ...o,
                      address_line_1: o.value,
                      latitude: latitude,
                      longitude: longitude,
                    };
                    
                    if (o.name === "Pahang" || o.name.includes("Pahang")) {
                      console.log(`City ${o.name} - coord: ${o.coord} -> lat: ${mappedItem.latitude}, lng: ${mappedItem.longitude}`);
                      console.log(`Parsed types - lat: ${typeof mappedItem.latitude}, lng: ${typeof mappedItem.longitude}`);
                    }
                    
                    return mappedItem;
                  })}
                  selected={selectedLocation}
                  onPress={(index) => {
                    pickedItem(index);
                  }}
                  // title={item.name}
                  isCheckbox
                  filterText={debouncedSearchText}
                />
              )}
            </>
          )}
        </ScrollView>
        <Centered style={{ width: "100%" }}>
          <Row>
            <Button
              type="secondary"
              style={{
                marginTop: 12,
                borderColor: "rgba(0,0,0,0.2)",
              }}
              label="Clear"
              onPress={() => {
                dispatch(
                  setSearchFilter({
                    ...filters,
                    states: [],
                    selectedLocations: [],
                  })
                );
                props.navigation.goBack();
              }}
            />
            <Button
              type="primary"
              style={{ marginTop: 12 }}
              label="Save"
              onPress={() => {
                onConfirm();
              }}
            />
          </Row>
        </Centered>
      </View>
    </View>
  );
}

const styles = {
  resultTitle: {
    marginLeft: 24,
    fontWeight: "bold",
    fontFamily: "NotoSans-Bold",
  },
  resultAddress: {
    marginLeft: 24,
    marginTop: 4,
    maxWidth: "88%",
    fontSize: normalize(13),
  },
  resultContainer: {
    marginBottom: 18,
    width: "100%",
    alignSelf: "center",
    height: 1,
    backgroundColor: "rgba(0,0,0,0.03)",
  },
  resultRowContainer: {
    marginBottom: 18,
    alignItems: "center",
    justifyContent: "space-between",
  },
  recentContainer: {
    marginTop: 20,
    padding: 8,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "space-between",
  },
};
